<script>
import { mapGetters, mapActions } from "vuex";

import genders from "../service/genders";
import AdminAppShowDetail from "./AdminAppShowDetail.vue";
import AppConfirm from "./modals/app-confirm.vue";
import app from "~/src/App.vue";
import AdminAppShowPhoto from "./AdminAppShowCertificatePhoto.vue";

export default {
  components: { AdminAppShowDetail, AppConfirm, AdminAppShowPhoto },
  data: () => ({
    genders,
    photo: null,
    acceptDialog: false,
    passedDialog: false,
    rejectDialog: false,
    paidDialog: false,
    failedDialog: false,
  }),

  computed: {
    ...mapGetters("admin-olimpiada2024s", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,
    disableReject() {
      const values = Object.values(this.application.reviews);
      return !values.filter((x) => `${x || ""}`.trim()).length;
    },

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,
    isReadonly: (vm) => vm.user.role == "ADMIN_OBSERVER",
    isSuperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
  },

  methods: {
    app() {
      return app;
    },
    ...mapActions("admin-olimpiada2024s", []),

    getGender(id) {
      return this.genders.find((x) => x.id == id) || {};
    },

    /*onAccept() {
      this.ACCEPT_APPLICATION({ id: this.application.id }).then((status) => {
        if (status) {
          window.location.reload();
        }
      });
    },*/

    /*onPassed() {
      this.PASSED_APPLICATION({ id: this.application.id }).then((status) => {
        if (status) {
          window.location.reload();
        }
      });
    },*/

    /*onFailed() {
      this.FAILED_APPLICATION({ id: this.application.id }).then((status) => {
        if (status) {
          window.location.reload();
        }
      });
    },*/

    /* onPaid() {
      this.PAID_APPLICATION({ id: this.application.id }).then((status) => {
        if (status) {
          window.location.reload();
        }
      });
    },*/

    /*onRejects() {
      const params = {
        id: this.application.id,
        reviews: this.application.reviews,
      };
      this.REJECT_APPLICATION(params).then((status) => {
        if (status) {
          window.location.reload();
        }
      });
    },*/
  },
};
</script>

<template>
  <div>
    <v-form
      :readonly="isReadonly"
      @submit.prevent="() => false"
      ref="form"
      lazy-validation
    >
      <v-row>
        <v-col cols="12" md="6">
          <div class="-data-wrap">
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Full name')"
              :text="application.fullName"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Personal phone number')"
              :text="application.mobilePhone"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Language of instruction')"
              :text="application.language"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Region')"
              :text="application.region"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('City / District')"
              :text="application.district"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Maktab raqami')"
              :text="application.schoolNumber"
            />
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Olimpiada science')"
              class="pt-4"
              :text="application.olimpiaScience"
            />
            <admin-app-show-detail
              :title="$t('Science 1')"
              class="pt-4"
              :text="application.science1"
            />
            <admin-app-show-detail
              :title="$t('Science 2')"
              class="pt-4"
              :text="application.science2"
            />
            <admin-app-show-detail
              :title="$t('Science 3')"
              class="pt-4"
              :text="application.science3"
            />
            <admin-app-show-detail
              :title="$t('toplagan bali')"
              class="pt-4"
              :text="application.result"
            />
            <admin-app-show-detail
              v-if="application.vaucher != null"
              :title="$t('Vaucher mavjud')"
              class="pt-4"
              :text="application.vaucher"
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <admin-app-show-detail :title="$t('Certificates')" />
          <admin-app-show-photo
            class="pt-2"
            v-if="application.certificateImg"
            :url="application.certificateImg"
          />
        </v-col>
      </v-row>
    </v-form>

    <app-confirm
      v-model="acceptDialog"
      :text="$t('Accept?')"
      @accept="onAccept"
    />

    <app-confirm
      v-model="passedDialog"
      :text="$t('Passed?')"
      @accept="onPassed"
    />

    <app-confirm
      v-model="rejectDialog"
      :text="$t('Reject?')"
      @accept="onRejects"
    />
    <app-confirm
      v-model="failedDialog"
      :text="$t('Failed?')"
      @accept="onFailed"
    />
  </div>
</template>

<style lang="scss" scoped>
.-data-wrap {
  height: 100%;
  border-left: 1px solid rgba(128, 128, 128, 0.699);

  padding-left: 15px;
}

.-title {
  font-size: 14px;
}

.-text {
  font-weight: 500;
}
</style>
